// Equipment type enum mapping (based on HasEquipmentType in Ruby)
// Maps integer values to enum string keys
export const EQUIPMENT_TYPE_MAP = {
  0: "desktop",
  1: "laptop",
  2: "tablet",
  3: "smartphone",
  4: "printer",
  5: "monitor",
  6: "server",
  7: "router",
  8: "switch",
  9: "wifi",
  10: "storage",
  11: "firewall",
  12: "videoprojector",
  13: "tv",
  14: "load_balancer",
  15: "lan_controller",
  16: "wan_appliance",
  17: "mini_pc_factory",
  18: "bar_code_reader",
  19: "mobile_computer",
  20: "thin_client",
  21: "fixed_phone",
  22: "hard_drive",
  23: "digital_camera",
  24: "security_camera",
  25: "pabx",
  26: "ip_phone",
  27: "audio_conference",
  28: "visio_conference",
  29: "tetra_radio",
  30: "bus_ticket_validation",
  31: "tram_ticket_validation",
  32: "pis_bus_shelters",
  33: "validation_gantries",
  34: "information_screens",
  35: "onboard_computers",
  36: "embedded_consoles",
  37: "ticket_reloading_devices",
  38: "embedded_routers",
  39: "embedded_jlb",
  40: "vending_machines",
  41: "embedded_tft",
  42: "point_of_sale_terminals",
  43: "syspad_displays",
  44: "advertising_spaces",
  45: "passenger_information_terminals",
  46: "orientation_touch_screen",
  47: "ground_routers",
  48: "eto_central_unit",
  49: "docking_station",
  50: "keyboard",
  51: "mouse",
  52: "headphone",
  53: "external_battery",
  54: "usb_stick",
  55: "smartwatch",
  56: "transceiver",
  57: "card_reader",
}
